module.exports = __webpack_public_path__ + "static/media/TapThinDenseRoot2.1ba5119d.PNG";